import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { MandatoryAdditionalStyle, Style } from '../components.utils';

const componentConfigurationKey = 'divider';

interface DividerDataProps {
  dataId?: string;
}

interface DividerThemeProps {
  color: string;
}

type DividerComponentProps = MandatoryAdditionalStyle & DividerDataProps;

const createStyle = ({ color }: DividerThemeProps) => StyleSheet.create({
  divider: {
    backgroundColor: color,
    width: 'auto',
    height: '1px',
  },
});

export const Divider: React.FunctionComponent<DividerComponentProps> = props => {
  const themeProps = useTheme<DividerThemeProps>(componentConfigurationKey);
  const style = createStyle(themeProps);
  const { additionalStyle, dataId } = props;
  return <ErrorBoundary><div data-id={dataId} className={css(style.divider, additionalStyle.style as Style)} /></ErrorBoundary>;
};
